import { render, staticRenderFns } from "./AcademicRequest.html?vue&type=template&id=327bc7b2&scoped=true&"
import script from "./AcademicRequest.vue?vue&type=script&lang=js&"
export * from "./AcademicRequest.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRequest.scss?vue&type=style&index=0&id=327bc7b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bc7b2",
  null
  
)

export default component.exports